import script from "./CollectivitesSidebar.vue?vue&type=script&setup=true&lang=ts"
export * from "./CollectivitesSidebar.vue?vue&type=script&setup=true&lang=ts"

import "./CollectivitesSidebar.vue?vue&type=style&index=0&id=f43a78f4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f43a78f4"]])

export default __exports__